<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form
        class="clearfix"
        ref="dialogFormRef"
        :model="dialogForm"
        :disabled="true"
        label-width="136px"
      >
        <el-form-item class="half" label="任务名称" prop="scheduleName">
          <el-input v-model.trim="dialogForm.scheduleName" clearable placeholder="请输入任务名称" />
        </el-form-item>
        <el-form-item class="half" label="任务执行标识" prop="taskName">
          <el-select-dict dictType="SCHEDULE_TASK" v-model.trim="dialogForm.taskName" clearable
            placeholder="请选择任务执行标识" />
        </el-form-item>
        <el-form-item class="half" label="cron执行表达式" prop="cron">
          <el-input v-model="dialogForm.cron" placeholder="请输入cron执行表达式">
          </el-input>
        </el-form-item>
      
        <el-form-item class="half" label="接口提示信息" prop="operateMsg">
          <el-input
            v-model="dialogForm.operateMsg"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="操作日期" prop="createTime">
          <el-date-picker
            v-model="dialogForm.createTime"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">关 闭</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "ScheduleLogDialog",
  props: {
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialogForm: {
        scheduleName: "",
        taskName: ""
      } // 弹框表单
    }
  },
  watch: {
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        console.log("🚀 ~ val:", val)
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
  }
}
</script>
